Vendd.Scripts.load(function () {

    initTopMenu();
    
});

function initTopMenu() {
    
}
